(function () {
  'use strict';


  angular
    .module('individualCrewExpiryReport')
    	.directive('focusOnReport',function($timeout) {
		return {
			restrict : 'A',
			link : function(vm,$element,$attr) {
				vm.$watch($attr.focusOnReport,function(_focusVal) {
					$timeout(function() {
						_focusVal ? $element[0].focus() : $element[0].blur();
					});
				});
			}
		}
	})
    .controller('IndividualCrewExpiryReportCtrl', IndividualCrewExpiryReportCtrl);

  function IndividualCrewExpiryReportCtrl($sce,CommonFuelService,CommonMasterData,applicationConstants,MessageService,crewScheduleService,RemoteService,CommonLogicService) {
    var vm = this;
    vm.ctrlName = 'IndividualCrewExpiryReportCtrl';

    vm.model = {
            searchPanelToggle:true,
            searchCriteria:{
            	crewType :null,
            	crewName :null,
            	crewId:null
            },
            masterList: {
            	crewTypeList:[],
                crewNameList:[]

            },
            initialSearchDone:false,
            reportServerBaseUrl : null,
            reportDataUrl : ""
        };

    vm.clickOnSearch = function () {
        vm.model.searchPanelToggle = ! vm.model.searchPanelToggle;
        vm.model.initialSearchDone=false;
    };

    vm.submitSearch = function (params){
    	search(params);
    };

    vm.changeSearchField = function(searchParams, flag) {
		if (flag === 'crewType') {
			vm.model.masterList.crewNameList = loadCrewList(searchParams.crewType);
		 } else if (flag === 'crewName') {
			 vm.model.searchCriteria.crewId = searchParams.crewName.crewId;
		 }else if (flag === 'crewId'){
        vm.model.searchCriteria.crewType = [];
        vm.model.searchCriteria.crewName = null;

      }
    };

	function loadCrewList(crewType){
		var param = {};
		param.crewType = '';
		param.active = true;
		if (!!crewType) {
			param.crewType = crewType.crewTypeCode;
			CommonMasterData.loadCrewList(param, function(response) {
				vm.model.masterList.crewNameList = crewScheduleService
						.adaptCrewList(response);
			}, function() {
				console.log('Crew list retrieval error');
			});
		} else {
			vm.model.masterList.crewNameList = [];
		}
	}

    function search(params){
    	vm.model.searchPanelToggle = false;
    	vm.model.ruleList = [];
    	vm.model.searchCriteria = params;
    	var url = CommonLogicService.getReportUrl('individual_crew_expiry_report_new.rptdesign',{crewId:params.crewId});
    	vm.model.reportDataUrl = $sce.trustAsResourceUrl(url);
    }


    CommonMasterData.getCrewTypeList(function(crewTypeList){
    	vm.model.masterList.crewTypeList = crewTypeList;
    },function () {});


    CommonMasterData.getReportServerBaseUrl(
	    	function (baseUrl) {
	            vm.model.reportServerBaseUrl = baseUrl;
	        },
	        function (error) {
	            MessageService.error(error);
	        }
	    );

  }


}());
